export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const REQUEST_FAILED = "REQUEST_FAILED";

export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";

export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS";
export const UPDATE_TENANT_SUCCESS = "UPDATE_TENANT_SUCCESS";
export const UPDATE_DEFAULT_LOCATION_SUCCESS =
  "UPDATE_DEFAULT_LOCATION_SUCCESS";

export const ADD_SNACKBAR = "ADD_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";
